import { createContext, useContext } from 'react';
const TooltipPositionContext = /*#__PURE__*/createContext({
  isFlippedVertically: false,
  isFlippedHorizontally: false
});
export const TooltipPositionProvider = TooltipPositionContext.Provider;
export const TooltipPositionConsumer = TooltipPositionContext.Consumer;
export const useTooltipPosition = () => useContext(TooltipPositionContext);